class BooyaLoader {
    constructor() {
        this.ready(() => {
            this.initJQuery(this.initBooya);
        });
    }

    ready(callback) {
        if (document.readyState !== 'loading'){
            callback();
        } else {
            document.addEventListener('DOMContentLoaded', callback);
        }
    }

    initJQuery(callback) {
        const j = window.jQuery,
            jQueryVersion = j && j.fn && j.fn.jquery;

        if(jQueryVersion) {
            callback();
        } else {
            let script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.5.1/jquery.min.js';
            script.onload = function() {
                callback();
            };
            (document.getElementsByTagName("head")[0] || document.documentElement).appendChild(script);
        }
    }

    initBooya() {
        const appID = window.booyaConfig && window.booyaConfig.appID || null,
            portalID = window.booyaConfig && window.booyaConfig.portalID || null,
            mode = window.booyaConfig && window.booyaConfig.__mode || 'live';

        // Auto detect brix environment from brix elements
        if(window.booyaConfig.__product !== 'brix' && ($('#brix-booya-signin').length || $('#brix-booya-user-widget').length || $('.brix-dashboard-object-wrapper').length)) {
            window.booyaConfig.__product = 'brix';
            window.booyaConfig.__platform = 'hubspot';
        }

        function injectScripts() {
            const version = window.booyaConfig && window.booyaConfig.__version || 'latest';

            const dateNow = new Date(),
                cacheTag = `${dateNow.getFullYear()}-${dateNow.getMonth()}-${dateNow.getDate()}@${dateNow.getHours()}`;

            const head = $('head');

            // Add Booya CSS
            let link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = mode === 'local-assets'?'../dist/css/booya.css':`https://cdn.jsdelivr.net/npm/@inboundlabs/booya-ui@${version}/dist/css/booya.min.css?ctag=${encodeURIComponent(cacheTag)}`;
            const title = head.find('title');
            link.onload = () => {
                // Add Booya JS
                let script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = mode === 'local-assets'?'../dist/js/booya.js':`https://cdn.jsdelivr.net/npm/@inboundlabs/booya-ui@${version}/dist/js/booya.min.js?ctag=${encodeURIComponent(cacheTag)}`;
                head.append(script);
            };
            if(title.length) {
                title.after(link);
            } else {
                head.prepend(link);
            }
        }

        if(appID || portalID) {
            $.ajax({
                url: `${(mode === 'development'?'http://localhost:5000':'https://auth.booya.io')}${appID?`/${appID}/config`:`/config/${portalID}`}?version=${window.booyaConfig.__version || ''}&platform=${window.booyaConfig.__platform || ''}&product=${window.booyaConfig.__product || ''}&url=${encodeURIComponent(location.href)}`,
                type: "GET",
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                }
            }).done(function (data) {
                window.booyaConfig = {
                    ...(window.booyaConfig || {}),
                    ...data,
                    __setup: true,
                };

                injectScripts();
            }).fail(function (error) {
                if (error && error.responseText) {
                    let data = $.parseJSON(error.responseText);
                    if (data) {
                        if(data.reason === 'not_setup') {
                            window.booyaConfig = {
                                ...(window.booyaConfig || {}),
                                __setup: false,
                            };
                        }

                        if(data.__version) {
                            window.booyaConfig = {
                                ...(window.booyaConfig || {}),
                                __version: data.__version,
                            };
                        }
                    }
                }

                injectScripts();
            });
        }

        window.addEventListener('message', event => {
            const {type :eventType, eventName, id :formID} = event && event.data || {};
            if(eventType === 'hsFormCallback' && eventName === 'onFormReady' && formID) {
                const user = window.user || null;
                if(user && user.email) {
                    // Set email for hubspot form
                    const setHubSpotFormEmails = () => {
                        const emailInputSelector = `form#hsForm_${formID}.hs-form .hs-form-field.hs-email input.hs-input[type="email"]`;
                        $(emailInputSelector, $('.hbspt-form iframe.hs-form-iframe').contents()).val(user.email);
                        $(emailInputSelector).val(user.email);
                    };
                    setHubSpotFormEmails();
                    setTimeout(setHubSpotFormEmails, 200);
                }
            }
        });
    }
}

if(!window.booya) {
    const setConfig = config => {
        if(!window.booyaConfig) window.booyaConfig = {};
        window.booyaConfig = {
            ...(window.booyaConfig || {}),
            ...(config || {}),
            overrides: {
                ...(window.booyaConfig && window.booyaConfig.overrides || {}),
                ...(config && config.overrides || {}),
            },
        };
    };
    window.booya = {
        setConfig,
        overrideConfig: config => {
            setConfig({
                overrides: config,
            });
        },
        ready: function (callback) {
            if(!window.booyaQueue) window.booyaQueue = [];
            window.booyaQueue.push(callback);
        },
    };

    new BooyaLoader();
}
